import { useCallback } from 'react';
import { CrossAppService } from '@revenuewell/logic-cross-app';
import { useDesktop } from '@revenuewell/logic-desktop';
import { useConfig } from '@revenuewell/logic-config';
import { useOidc } from '@revenuewell/logic-oidc';
import { NavigationService } from '@revenuewell/logic-navigation';

export type UrlWebUsage = 'ThisPage' | 'NewTab';
export type UrlDesktopUsage = 'MainWindow' | 'DefaultBrowser' | 'DefaultBrowserCrossApp';

export type Options = {
  url?: Promise<string | undefined> | string | undefined;
  web?: UrlWebUsage;
  desktop?: UrlDesktopUsage;
};

export function useUrl(optionsParam?: Options) {
  const { isDesktopApplication, openUrlInMainWindow, openUrlInBrowser, showMainWindow } = useDesktop();
  const options = Object.assign({ web: 'ThisPage', desktop: 'MainWindow'}, optionsParam);
  const { config } = useConfig();
  const { oidcService} = useOidc();
  const crossAppService = new CrossAppService(
    config,
    oidcService,
    new NavigationService()
  );

  const openUrl = useCallback(async (urlOverride?: string) => {
      const url = urlOverride || (typeof options?.url === 'string' && options?.url) || (options?.url && (await options?.url));

      if (url) {
        if (isDesktopApplication()) {
          if (options.desktop === 'MainWindow') {
            openUrlInMainWindow(url);
            showMainWindow();
          } else if (options.desktop === 'DefaultBrowserCrossApp') {
            const crossAppUrl = await crossAppService.createCrossAppV1Url(url);
            openUrlInBrowser(crossAppUrl);
          } else if (options.desktop === 'DefaultBrowser') {
            openUrlInBrowser(url);
          }
        } else {
          if (options.web === 'ThisPage') {
            window.location.href = url;
          } else {
            window.open(url);
          }
        }
      }
    },
    [options?.url]
  );

  const open = useCallback(() => openUrl(), [openUrl]);

  return { open, openUrl };
}
